var _circle, _circle2, _circle3, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _g, _rect9, _rect10, _rect11, _g2, _g3, _rect12, _rect13, _rect14, _g4, _circle4, _circle5, _circle6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustration(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 593,
    height: 593,
    viewBox: "0 0 593 593",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 296.5,
    cy: 296.5,
    r: 296.5,
    fill: "#E064CC",
    fillOpacity: 0.05
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 296.5,
    cy: 296.5,
    r: 258.476,
    fill: "#E064CC",
    fillOpacity: 0.05
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 293.784,
    cy: 296.5,
    r: 212.303,
    fill: "#E064CC",
    fillOpacity: 0.05
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 174.731,
    y: 104.115,
    width: 256.212,
    height: 354.895,
    rx: 3.62137,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 194,
    width: 206,
    height: 36,
    rx: 1.81069,
    fill: "#F3F3F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 245,
    width: 206,
    height: 36,
    rx: 1.81069,
    fill: "#F3F3F3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 143,
    width: 206,
    height: 36,
    rx: 1.81069,
    fill: "#F3F3F3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 347,
    width: 206,
    height: 36,
    rx: 1.81069,
    fill: "#F3F3F3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 398,
    width: 206,
    height: 36,
    rx: 1.81069,
    fill: "#F3F3F3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 296,
    width: 206,
    height: 36,
    rx: 1.81069,
    fill: "#F3F3F3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 240.35,
    width: 52.5099,
    height: 15.3908,
    rx: 1.81069,
    fill: "#FCEFFA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_181_240)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 220,
    y: 307,
    width: 231.786,
    height: 69,
    rx: 2.67961,
    fill: "white"
  }))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 230.049,
    y: 320.398,
    width: 44.8835,
    height: 42.8738,
    rx: 2.67961,
    fill: "#66C085"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 283.641,
    y: 320.398,
    width: 152.738,
    height: 11.3883,
    rx: 1.33981,
    fill: "#66C085",
    fillOpacity: 0.11
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 283.641,
    y: 339.155,
    width: 38.8544,
    height: 11.3883,
    rx: 1.33981,
    fill: "#66C085",
    fillOpacity: 0.11
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_181_240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.184 336.476H246.126C245.386 336.476 244.786 337.076 244.786 337.816V345.854C244.786 346.594 245.386 347.194 246.126 347.194H258.184C258.924 347.194 259.524 346.594 259.524 345.854V337.816C259.524 337.076 258.924 336.476 258.184 336.476Z",
    stroke: "white",
    strokeWidth: 1.33981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.786 340.495H259.524",
    stroke: "white",
    strokeWidth: 1.33981,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_181_240)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.4809,
    y: 238.105,
    width: 313.249,
    height: 93.2504,
    rx: 3.62137,
    fill: "white"
  }))), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 95.061,
    y: 256.212,
    width: 60.658,
    height: 57.942,
    rx: 3.62137,
    fill: "#FD377E"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 167.489,
    y: 256.212,
    width: 206.418,
    height: 15.3908,
    rx: 1.81069,
    fill: "#FCEFFA"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 167.489,
    y: 281.562,
    width: 52.5099,
    height: 15.3908,
    rx: 1.81069,
    fill: "#FCEFFA"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_181_240)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M133.086 277.94H116.789C115.789 277.94 114.979 278.751 114.979 279.751V290.615C114.979 291.615 115.789 292.426 116.789 292.426H133.086C134.086 292.426 134.896 291.615 134.896 290.615V279.751C134.896 278.751 134.086 277.94 133.086 277.94Z",
    stroke: "white",
    strokeWidth: 1.81069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.979 283.373H134.896",
    stroke: "white",
    strokeWidth: 1.81069,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 385,
    cy: 119,
    r: 3,
    fill: "#FD377E"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 400,
    cy: 119,
    r: 3,
    fill: "#66C085"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 415,
    cy: 119,
    r: 3,
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_181_240",
    x: 193.204,
    y: 282.883,
    width: 285.379,
    height: 122.592,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.67961
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 13.3981
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_181_240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_181_240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_181_240",
    x: 45.2672,
    y: 205.513,
    width: 385.676,
    height: 165.678,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.62137
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18.1069
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_181_240"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_181_240",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_181_240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0777,
    height: 16.0777,
    fill: "white",
    transform: "translate(244.117 333.796)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_181_240"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.7282,
    height: 21.7282,
    fill: "white",
    transform: "translate(114.073 274.319)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustration);
export default __webpack_public_path__ + "static/media/illustration.5d3461c25df8042d0c2a407f4ceddb06.svg";
export { ForwardRef as ReactComponent };